module.exports = __webpack_public_path__ + "static/media/permanent-logo.47326d1e.png";